/* eslint-disable */
import convertList from '../convertList';
import filters from '../filters';
// import getDetail from '../getDetail/getPeopleDetailByUin';
// import sign from '../sign';
import  { envDomain } from '@/common/contact-selector/utils/domainConfig'
// 加载临界值，小于该数字直接加载详情
const LOAD_DETAIL_NUM = 100;

export default function(config) {
    const moreConfig = {
        totalState: false
    };
    const selfConfig = config.extendConfig && config.extendConfig[config.base.field] || {};
    let count = 0;
    let uins = [];
    const datasource = [];
    // if (config.base.config.loadByPaginate) {
        return new Promise((resolve, reject) => {
            _getQQFriendGroup()
                .then(res => {
                    console.log('getQQFriend new:', JSON.stringify(res));
                    if (window.parseInt(res.code) === 0 && res.data && res.data.groups) {
                        res.data.groups.forEach(group => {
                            datasource.push({
                                ...group,
                                total: group.size,
                                uins: []
                            });
                        });
                        return new Promise(resolve => {
                            resolve(datasource);
                        });
                    }
                    reject(res);
                })
                .then(detailList => {
                    config = Object.assign(config, moreConfig);
                    const newList = convertList(detailList, {
                        list: 'uins',
                        groupName: 'name'
                    }, config);
                    //个Q不需要设置主号的相关信息
                    //resolve(filters.setKfuinTypeInList(newList));
                    resolve(newList);
                })
                .catch(err => {
                    reject(err);
                });
        });
    // } else {
    //     return new Promise((resolve, reject) => {
    //         // 单向好友列表
    //         let oneWayUins = [];
    //         _getQQFriendUin()
    //             .then(res => {
    //                 console.log('getQQFriend:', JSON.stringify(res));
    //                 if (window.parseInt(res.code) === 0 && res.data && res.data.groups) {
    //                     if(res.data.oneWayUins){
    //                         oneWayUins = res.data.oneWayUins;
    //                         window.QD_QQFRIEND_ONEWAYUINS = oneWayUins;
    //                     }
    //                     res.data.groups.forEach(group => {
    //                         if (group && group.uins && group.uins.length) {
    //                             datasource.push(group);
    //                             uins = uins.concat(group.uins || []);
    //                         }
    //                     });
    //                     count = uins.length;

    //                     if (count <= LOAD_DETAIL_NUM && count > 0) {
    //                         return _getDetail(datasource, uins);
    //                     }
    //                     return new Promise(resolve => {
    //                         resolve(datasource);
    //                     });
    //                 }
    //                 reject(res);
    //             })
    //             .then(detailList => {
    //                 const newList = convertList(detailList, {
    //                     list: 'uins',
    //                     groupName: 'name'
    //                 }, config);
    //                 return filters.setKfuinTypeInList(newList);
    //             })
    //             .then(list => {
    //                 // 为单向关系链的联系人数据打标记
    //                 const newList = sign.oneWayRelationshipChain(list, 'QQFriend', {
    //                     oneWayUins,
    //                     ...selfConfig
    //                 });
    //                 resolve(newList);
    //             })
    //             .catch(err => {
    //                 reject(err);
    //             });
    //     });
    // }
}

/**
 * 根据uin获取qq好友详情，输出结果是将datasource里面的uin字符串数组，换成好友详情的对象数组
 * @param {array} datasource
 * @param {array} uins
 * @returns {promise}
 */
// function _getDetail(datasource, uins) {
//     return new Promise((resolve, reject) => {
//         getDetail({
//             ids: uins
//         })
//             .then(res => {
//                 const newList = [];
//                 datasource.forEach(group => {
//                     const groupItem = {
//                         name: group.name,
//                         id: group.id,
//                         size: group.size,
//                         uins: []
//                     };
//                     group.uins.forEach(uin => {
//                         if (res[uin]) {
//                             groupItem.uins.push({
//                                 id: uin,
//                                 name: res[uin].name,
//                                 face: res[uin].face
//                             });
//                         }
//                     });
//                     newList.push(groupItem);
//                 });
//                 resolve(newList);
//             })
//             .catch(err => {
//                 reject(err);
//             });
//     });
// }

// function _getQQFriendUin() {
//     return Vue.prototype.$ajax.crossGet(`${envDomain.gateway}/hb/selector/getQQFriendUin`);
// }

function _getQQFriendGroup() {
    return Vue.prototype.$_sAjax.crossGet(`${envDomain.gateway}/v1/b2b/selector/getQQFriendGroup`);
}
